module.exports = {
      id: "prayer-header-usage",
      viewBox: "0 0 300 193",
      url: "/" + "svg-sprite-e82dc0c57c0a843613ac9ad873433208.svg#prayer-header",
      toString: function () {
        return this.url;
      }
    }